import React, { PureComponent, PropTypes } from 'react';

import { connect } from 'react-redux';
import { Redirect } from 'react-router';
import { logOut } from '../../redux/actions';


class Logout extends PureComponent {
  static propTypes = {
    user: PropTypes.object,
    logOut: PropTypes.func.isRequired,
  };

  componentDidMount() {
    this.props.logOut();
  }

  render() {
    const { user } = this.props;
    
    return !user? <Redirect to="/" /> : null;
  }
}

const mapStateToProps = (state, props) => state.user;

export default connect(mapStateToProps, {logOut})(Logout);


// WEBPACK FOOTER //
// ./src/scenes/Logout/index.js